export const formatInteger = (integer: number | bigint) =>
  integer.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
